import clsx from 'clsx';
import { getActionGroupClasses } from '../../utils/actionGroupClasses';

const ActionGroup = ({
  as: Component = 'div',
  children,
  className,
  align = 'start',
  wrap = true,
  stackOnMobile = false,
  reverseOnMobile = false,
  expandChildrenOnMobile = false,
}) => (
  <Component
    className={clsx(
      getActionGroupClasses({
        align,
        wrap,
        stackOnMobile,
        reverseOnMobile,
        expandChildrenOnMobile,
      }),
      className
    )}
  >
    {children}
  </Component>
);

export default ActionGroup;
